import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import { lightPalette } from '../../../theme';

const CustomTooltip = ({ children, title, placement }) => (
  //   const tooltipTheme = theme === "light" ? "light" : "dark";
  <Tooltip
    title={title}
    enterDelay={800}
    leaveDelay={0}
    arrow
    // disableFocusListener
    // disableTouchListener
    // TransitionComponent={Fade}
    // TransitionProps={{ timeout: 500 }}
    // position="top"
    // offset={{ x: 1000, y: 10 }}
    // followCursor
    // theme={tooltipTheme}
    placement={placement}
    // PopperProps={{ disablePortal: true }}
    // PopperProps={{
    //   popperOptions: {
    //     modifiers: {
    //       offset: {
    //         enabled: true,
    //         offset: '40px, 40px',
    //       },
    //     },
    //   },
    // }}
    slotProps={{
      tooltip: {
        sx: {
          backgroundColor: lightPalette.secondaryWhite.main,
          color: lightPalette.secondaryBlack.main,
          boxShadow: '0px 0px 11px 4px rgba(0, 0, 0, 0.08)',
          borderRadius: '4px',
          fontFamily: 'Heebo',
          fontWeight: 400,
          fontSize: '11px',
        },
      },
      arrow: {
        sx: {
          color: lightPalette.secondaryWhite.main,
        },
      },
    }}
  >
    {children}
  </Tooltip>
);

CustomTooltip.defaultProps = {
  title: undefined,
  placement: 'bottom',
};

CustomTooltip.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
  placement: PropTypes.string,
};

export default CustomTooltip;
